//@flow
import * as React from 'react';
import classnames from 'classnames';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import {
    PopoverPlaceEnum,
    PopoverTriggerEnum
} from 'common/components/core/popover/popOverFactory';
import { Icon } from '@locus-taxy/neo-ui';
import ZendeskDialog from 'common/components/core/common/ZendeskDialog';

type Props = {
    theme: Object,
    status: string,
    error: string,
    uploadError: string,
    issueId?: string,
    response: Object,
    dialogActive: boolean,
    onFormChange: () => void,
    onHelpClick: () => void,
    onDialogOpen: () => void,
    onDialogClose: () => void,
    onUpload: () => void
};

const DefaultActionComponent = ({ theme, tooltipText, onDialogOpen, icon }) => (
    <DivWithPopover
        theme={theme}
        preferPlace={PopoverPlaceEnum.Right}
        triggerPopoverOn={PopoverTriggerEnum.Hover}
        popOverContent={tooltipText || null}
        className={classnames(theme.item, theme.tooltipDiv)}
        onClick={onDialogOpen}
    >
        <Icon icon={icon} size="xLarge" />
    </DivWithPopover>
);

const ZendeskWidgetFactory = ({ ActionComponent = DefaultActionComponent }) => {
    class ZendeskWidget extends React.PureComponent<Props, void> {
        render() {
            const {
                theme,
                status,
                error,
                response,
                onHelpClick,
                onDialogOpen,
                onDialogClose,
                onUpload,
                dialogActive,
                onFormChange,
                formInputs,
                isFormValid,
                uploadError,
                issueId,
                tooltipText,
                isEditOrViewPlanScreen,
                icon,
                dialogHeader
            } = this.props;

            return (
                <>
                    <ActionComponent
                        theme={theme}
                        tooltipText={tooltipText}
                        onDialogOpen={onDialogOpen}
                        icon={icon}
                    />
                    {dialogActive ? (
                        <ZendeskDialog
                            onFormChange={onFormChange}
                            formInputs={formInputs}
                            isFormValid={isFormValid}
                            onDialogClose={onDialogClose}
                            onHelpClick={onHelpClick}
                            active={dialogActive}
                            status={status}
                            error={error}
                            response={response}
                            uploadError={uploadError}
                            issueId={issueId}
                            onUpload={onUpload}
                            isEditOrViewPlanScreen={isEditOrViewPlanScreen}
                            dialogHeader={dialogHeader}
                        />
                    ) : null}
                </>
            );
        }
    }
    return ZendeskWidget;
};

export default ZendeskWidgetFactory({});
export { ZendeskWidgetFactory };
